import { httpConsulta } from "../../../../services/apiManagement/Http.interceptor";

export const getPainelChamada = (data: string) => {
    return httpConsulta.get(`/getPainelChamadaEspera?cd=${data}`);
}